export const COMPANY_DEFAULTS = {
  name: 'Zovcur Pharma',
  address: '3/218, Pandian Salai, Saraswathi Nagar, Neelankarai, Chennai, Tamil Nadu 600115',
  dlNo: 'TN/Z04/20B/01482',
  phone: '072004 83640'
};

export const COMPANY_GSTIN = '33AACCZ7621B1ZN';

/** MRP & doctor price per strip (10 tablets). 1 box = 10 strips. */
export const PRODUCT_CATALOG = [
  { name: 'Zovfolic', mrp: 70, rate: 50, stripSize: 10, stripsPerBox: 10 },
  { name: 'Ferrozov', mrp: 275, rate: 193, stripSize: 10, stripsPerBox: 10 },
  { name: 'Calzov', mrp: 152.5, rate: 107, stripSize: 10, stripsPerBox: 10 },
  { name: 'Zov-B12', mrp: 200, rate: 140, stripSize: 10, stripsPerBox: 10 },
  { name: 'Zovandro Q10', mrp: 1204, rate: 843, stripSize: 10, stripsPerBox: 10 },
  { name: 'Zoviva', mrp: 130.5, rate: 91, stripSize: 10, stripsPerBox: 10 },
  { name: 'Zovgest', mrp: 347.5, rate: 278, stripSize: 10, stripsPerBox: 10 },
  { name: 'Dydozov', mrp: 1330, rate: 1064, stripSize: 10, stripsPerBox: 10 }
];

export const PRODUCT_OPTIONS = PRODUCT_CATALOG.map((item) => item.name);

export const DEFAULT_STRIP_SIZE = 10;
export const DEFAULT_STRIPS_PER_BOX = 10;

export const formatProductName = (name) => String(name || '').trim().toUpperCase();

export const getProductPricing = (name) => {
  const key = formatProductName(name);
  return (
    PRODUCT_CATALOG.find((item) => formatProductName(item.name) === key) || null
  );
};

/** Pack sizes for strip ↔ tablet ↔ box conversion */
export const getProductPackaging = (name) => {
  const pricing = getProductPricing(name);
  return {
    stripSize: Number(pricing?.stripSize) || DEFAULT_STRIP_SIZE,
    stripsPerBox: Number(pricing?.stripsPerBox) || DEFAULT_STRIPS_PER_BOX
  };
};

/** Invoice qty is strips → tablets + box equivalent */
export const convertFromStrips = (strips, productName) => {
  const qty = Number(strips) || 0;
  const { stripSize, stripsPerBox } = getProductPackaging(productName);
  const boxes = stripsPerBox > 0 ? qty / stripsPerBox : 0;
  return {
    strips: qty,
    tablets: qty * stripSize,
    boxes,
    stripSize,
    stripsPerBox
  };
};

/** Stock/balance in boxes → strips + tablets */
export const convertFromBoxes = (boxes, productName) => {
  const qty = Number(boxes) || 0;
  const { stripSize, stripsPerBox } = getProductPackaging(productName);
  const strips = qty * stripsPerBox;
  return {
    boxes: qty,
    strips,
    tablets: strips * stripSize,
    stripSize,
    stripsPerBox
  };
};

export const formatBoxQty = (value) => {
  const n = Number(value) || 0;
  if (Number.isInteger(n)) return String(n);
  return n.toLocaleString('en-IN', { maximumFractionDigits: 2 });
};

export const INVOICE_DEFAULTS = {
  billType: 'D-CREDIT BILL',
  pageNo: '1/1',
  stateCode: '33',
  stateName: 'Tamil Nadu',
  deliveryType: 'Picklist',
  gstin: COMPANY_GSTIN
};

export const BANK_DEFAULTS = {
  bank: 'Zovcur Pharma Pvt Ltd',
  acNo: '234305001462',
  ifsc: 'ICIC0002343',
  branch: 'Govindan Road, West Mambalam'
};

export const applyInvoiceCompanyDefaults = (invoice) => ({
  ...invoice,
  company: { ...invoice.company, dlNo: COMPANY_DEFAULTS.dlNo },
  bankDetails: { ...BANK_DEFAULTS }
});

export const INDIAN_STATES = [
  { code: '01', name: 'Jammu & Kashmir' },
  { code: '02', name: 'Himachal Pradesh' },
  { code: '03', name: 'Punjab' },
  { code: '04', name: 'Chandigarh' },
  { code: '05', name: 'Uttarakhand' },
  { code: '06', name: 'Haryana' },
  { code: '07', name: 'Delhi' },
  { code: '08', name: 'Rajasthan' },
  { code: '09', name: 'Uttar Pradesh' },
  { code: '10', name: 'Bihar' },
  { code: '11', name: 'Sikkim' },
  { code: '12', name: 'Arunachal Pradesh' },
  { code: '13', name: 'Nagaland' },
  { code: '14', name: 'Manipur' },
  { code: '15', name: 'Mizoram' },
  { code: '16', name: 'Tripura' },
  { code: '17', name: 'Meghalaya' },
  { code: '18', name: 'Assam' },
  { code: '19', name: 'West Bengal' },
  { code: '20', name: 'Jharkhand' },
  { code: '21', name: 'Odisha' },
  { code: '22', name: 'Chhattisgarh' },
  { code: '23', name: 'Madhya Pradesh' },
  { code: '24', name: 'Gujarat' },
  { code: '26', name: 'Dadra & Nagar Haveli and Daman & Diu' },
  { code: '27', name: 'Maharashtra' },
  { code: '29', name: 'Karnataka' },
  { code: '30', name: 'Goa' },
  { code: '31', name: 'Lakshadweep' },
  { code: '32', name: 'Kerala' },
  { code: '33', name: 'Tamil Nadu' },
  { code: '34', name: 'Puducherry' },
  { code: '35', name: 'Andaman & Nicobar Islands' },
  { code: '36', name: 'Telangana' },
  { code: '37', name: 'Andhra Pradesh' },
  { code: '38', name: 'Ladakh' }
];

export const getInvoiceStateLabel = (invoice) =>
  invoice?.customer?.state ||
  invoice?.invoiceDetails?.stateName ||
  '—';

export const findIndianState = (nameOrCode) => {
  if (!nameOrCode) return null;
  const normalized = String(nameOrCode).trim().toLowerCase();
  return (
    INDIAN_STATES.find(
      (s) =>
        s.code === normalized ||
        s.name.toLowerCase() === normalized
    ) || null
  );
};

export const createEmptyProduct = () => ({
  id: `${Date.now()}-${Math.random()}`,
  product: '',
  batchNo: '',
  exp: '',
  qty: '',
  rate: '',
  mrp: '',
  gstPercent: '5'
});

export const computeLine = (product) => {
  const qty = Number(product.qty) || 0;
  const rate = Number(product.rate) || 0;
  const gstPercent = Number(product.gstPercent) || 0;
  const base = qty * rate;
  const gstAmount = (base * gstPercent) / 100;
  const total = base + gstAmount;
  return { base, gstAmount, total, qty };
};

export const computeInvoiceTotals = (products = []) => {
  let items = 0;
  let quantity = 0;
  let baseAmount = 0;
  let gstTotal = 0;
  const gstBuckets = {};

  products.forEach((p) => {
    const line = computeLine(p);
    if (!p.product && line.qty === 0) return;
    items += 1;
    quantity += line.qty;
    baseAmount += line.base;
    gstTotal += line.gstAmount;
    const pct = String(p.gstPercent || '0');
    if (!gstBuckets[pct]) gstBuckets[pct] = { base: 0, gst: 0, amount: 0 };
    gstBuckets[pct].base += line.base;
    gstBuckets[pct].gst += line.gstAmount;
    gstBuckets[pct].amount += line.total;
  });

  const sgst = gstTotal / 2;
  const cgst = gstTotal / 2;
  const invoiceAmount = baseAmount + gstTotal;
  const roundedNetAmount = Math.round(invoiceAmount);

  return {
    items,
    quantity,
    baseAmount,
    sgst,
    cgst,
    gstTotal,
    invoiceAmount,
    roundedNetAmount,
    gstBuckets
  };
};

const ones = ['', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine'];
const tens = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];
const teens = ['Ten', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen'];

const twoDigits = (n) => {
  if (n < 10) return ones[n];
  if (n < 20) return teens[n - 10];
  return `${tens[Math.floor(n / 10)]}${ones[n % 10] ? ` ${ones[n % 10]}` : ''}`.trim();
};

const threeDigits = (n) => {
  if (n === 0) return '';
  const hundred = Math.floor(n / 100);
  const rest = n % 100;
  const hundredPart = hundred ? `${ones[hundred]} Hundred` : '';
  const restPart = rest ? twoDigits(rest) : '';
  return [hundredPart, restPart].filter(Boolean).join(' ');
};

export const numberToWordsINR = (amount) => {
  const num = Math.round(Number(amount) || 0);
  if (num === 0) return 'Zero Rupees Only';

  const crore = Math.floor(num / 10000000);
  const lakh = Math.floor((num % 10000000) / 100000);
  const thousand = Math.floor((num % 100000) / 1000);
  const hundredBlock = num % 1000;

  const parts = [];
  if (crore) parts.push(`${threeDigits(crore)} Crore`);
  if (lakh) parts.push(`${threeDigits(lakh)} Lakh`);
  if (thousand) parts.push(`${threeDigits(thousand)} Thousand`);
  if (hundredBlock) parts.push(threeDigits(hundredBlock));

  return `${parts.join(' ')} Rupees Only`;
};

export const buildEmptyInvoice = (invoiceNumber = '') => ({
  id: '',
  invoiceNumber,
  company: { ...COMPANY_DEFAULTS },
  customer: { doctor: '', address: '', phone: '', state: '' },
  invoiceDetails: {
    billType: INVOICE_DEFAULTS.billType,
    billNo: '',
    pageNo: INVOICE_DEFAULTS.pageNo,
    billDate: new Date().toISOString().split('T')[0],
    orderDate: new Date().toISOString().split('T')[0],
    dueDate: '',
    salesmanName: '',
    stateCode: INVOICE_DEFAULTS.stateCode,
    stateName: INVOICE_DEFAULTS.stateName,
    gstin: INVOICE_DEFAULTS.gstin,
    regNo: '',
    deliveryType: INVOICE_DEFAULTS.deliveryType
  },
  products: [createEmptyProduct()],
  bankDetails: { ...BANK_DEFAULTS },
  createdAt: new Date().toISOString()
});
